import React, { useState, useRef, useEffect } from 'react'
import { withApi } from 'shared-ui/api/ApiContext'
import UserIcon from 'shared-ui/assets/img/user-icon.svg'

const HeaderUserItem = ({ member, className = '', api }) => {
  const { userRole, userFirstName, userLastName } = member || {}
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)
  useEffect(() => {
    if (open) {
      document.body.classList.add('user-dropdown-open')
    } else {
      document.body.classList.remove('user-dropdown-open')
    }
    return () => document.body.classList.remove('user-dropdown-open')
  }, [open])

  const handleClickOutside = e => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = async () => {
    try {
      const { request } = api.logout()
      await request
    } catch (e) {
      console.error('Error while logging out', e)
    }
  }

  return (
    <div className="relative" ref={wrapperRef}>
      {/* Trigger button */}
      <div
        onClick={() => setOpen(!open)}
        className="flex cursor-pointer items-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm shadow-sm transition hover:bg-gray-50"
      >
        <UserIcon className="mr-2 h-5 w-5 text-gray-700" />
        <span className="max-w-[100px] truncate font-medium text-gray-900">{userFirstName}</span>
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute z-[1001] mt-2 w-72 overflow-hidden rounded-xl border border-gray-300 bg-white shadow-lg md:right-0">
          <div className="p-4">
            <div className="mb-1 flex items-center justify-between">
              <p className="text-grey-400 text-sm">Account Info</p>
              <span className="bg-grey-500 rounded-full px-3 py-1 text-xs font-bold text-white shadow-sm">
                {userRole}
              </span>
            </div>
            <strong className="text-gray-900">{`${userFirstName} ${userLastName}`}</strong>
          </div>
          <hr className="border-gray-300" />
          <button
            onClick={handleLogout}
            className="text-red hover:text-red w-full py-3 text-center text-sm font-medium transition"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  )
}

export default withApi(HeaderUserItem)
